<script>
//   const url = 'http://192.168.9.52:8060';
  const url = 'https://api.boomake.com';
  const url2 = 'http://api.boomake.com';
  
  export default {
    url,
    url2
  }
</script>